// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f56528e1","488":"f12a940d"}[chunkId] + ".chunk.js";
};